module.exports = __webpack_public_path__ + "media/src/images/bg_green-a071cb6dbb84521501fd8c441956776f.png";